<mat-dialog-content class="contentModal">
    <div class="container-fluid" loader [switch]="loader">
        <div class="aling">
            <div class="table-sio w-100 ">
                <div class="row-sio w-100">
                    <div class="cell-sio w-100">
                        <div class="padding-txt">
                            <label class="font-marcameTxt">¿No esta tu vehículo?</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-marcameTxt">Nos puedes marcar</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-numero">55442 46837</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-marcameTxt"> o te podemos marcar</label>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row-sio w-100">
                    <div class="cell-sop w-100">
                        <mat-form-field class="aling">
                            <input matInput id="btnTelefono" placeholder="Teléfono/Celular" TypeValidation="number" maxlength="10" [(ngModel)]="telefono" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row-sio w-100">
                    <div class="cell-sop w-100">
                        <mat-dialog-actions>
                            <button mat-flat-button class="m-auto" [color]="styleCocheSeguro?.colorBtn" id="btnMarcame" [disabled]="valida() || desactivar"
                                (click)="guardarRegistroInicioAyuda()" >Márcame</button>
                        </mat-dialog-actions>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
